import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import {
  insertCustomComponents,
} from './common';
import Utils from '../../utils';
import { Context } from '../context';
import CiblerAPI from '../ciblerApi';

export default class Notification extends CommonBlock {
  constructor(props) {
    super(props);

    this.closable = Utils.getCampaignData(this.props.notifBell, false);
    this.closed = !!(localStorage.getItem('currentClosed') || '').includes(this.props.campaignId)
      && this.closable;
    this.roundBell = Utils.getCampaignData(this.props.roundBell, false);
    this.bellBackground = Utils.getCampaignData(this.props.bellBackground, '');

    this.state = {
      content: '',
      showGift: false,
      open: !this.closed,
      contentOpen: !this.closed,
    };

    this.AssetsPath = `${Context.clientUrl}campaigns/assets/${props.campaignId}/${Context.device}`;
    this.contentWidth = this.state.open ? 0 : Utils.getCampaignData(this.props.iconWidth)
      ? Utils.getCampaignData(this.props.iconWidth)
      : 72;
  }

  componentDidMount() {
    const content = this.renderContent();

    if (content) {
      this.setState({ content });
    }

    this.contentWidth = document.getElementById('wioIconBlock').clientWidth;
  }

  getStyle = () => {
    let style = {
      transition: 'opacity 500ms linear, width 200ms linear, ' +
        'height 200ms linear, border-radius 200ms linear,' +
        'background 200ms linear',
      opacity: 1,
      backgroundSize: 'contain',
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '10px',
      overflow: 'hidden',
      padding: 0,
      boxShadow: '0px 5px 10px 0px #00000080',
    };
    if (Utils.getCampaignData(this.props.shadowColor)) style.boxShadow = `0px 5px 10px 0px ${Utils.getCampaignData(this.props.shadowColor)}80`;
    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${this.AssetsPath}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    if (Context.device === 'desktop') style.minWidth = '300px';
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    if (!this.state.open || !this.state.contentOpen) {
      style.height = `${this.contentWidth}px`;
      style.minWidth = 'initial';
    }

    if (!this.state.open) {
      style.width = `${this.contentWidth}px`;
      if (this.roundBell) {
        style.borderRadius = `${this.contentWidth}px`;
      }
      if (this.bellBackground) {
        style.backgroundColor = this.bellBackground;
      }
    }

    return style;
  };

  buttonStyle = {
    backgroundColor: '#fff',
    border: 'none',
    flex: 1,
    color: '#000',
    fontWeight: 'bold',
    margin: 0,
  };

  getAcceptButtonStyle = () => {
    const style = {
      ...this.buttonStyle,
      borderBottom: '1px solid gray',
      borderRadius: 0,
    };

    if (Utils.getCampaignData(this.props.acceptButtonFontColor)) style.color = Utils.getCampaignData(this.props.acceptButtonFontColor);
    if (Utils.getCampaignData(this.props.acceptButtonColor)) style.backgroundColor = Utils.getCampaignData(this.props.acceptButtonColor);
    if (Utils.getCampaignData(this.props.buttonFontSize)) style.fontSize = Utils.getCampaignData(this.props.buttonFontSize);

    return style;
  };

  getExitButtonStyle = () => {
    const style = {
      ...this.buttonStyle,
    };

    if (Utils.getCampaignData(this.props.exitButtonFontColor)) style.color = Utils.getCampaignData(this.props.exitButtonFontColor);
    if (Utils.getCampaignData(this.props.exitButtonColor)) style.backgroundColor = Utils.getCampaignData(this.props.exitButtonColor);
    if (Utils.getCampaignData(this.props.buttonFontSize)) style.fontSize = Utils.getCampaignData(this.props.buttonFontSize);

    return style;
  };

  getButtonsStyle = () => {
    const base = {
      display: 'flex',
      flexDirection: 'column',
      width: '30%',
      borderLeft: '1px solid gray',
    };

    return base;
  }

  getIconStyle = () => {
    const style = {
      width: '20%',
      padding: '15px',
      alignSelf: 'center',
      boxSizing: 'border-box',
    };

    if (this.contentWidth) {
      style.width = this.contentWidth;
      style.minWidth = this.contentWidth;
    }

    if (Utils.getCampaignData(this.props.iconWidth)) style.width = Utils.getCampaignData(this.props.iconWidth);

    return style;
  }

  handleAcceptClick = () => {
    if (!this.state.showGift) {
      window.WIO.track('discoverBlock', this.props.campaignId, Context.sessionId);
      CiblerAPI.discoverGift(Context[this.props.campaignId], this.completeGift(this.props.content?.value));
      return;
    }

    if (this.buttonType.includes('exit')) {
      window.location.href = this.exitUrl;
    }
    if (this.buttonType.includes('newtab')) {
      window.open(this.exitUrl, "_blank");
    }
    if (this.buttonType.includes('close')) {
      this.closable ? this.toggleOpen() : this.props.refuseBlock();
    }

    if (this.buttonType.includes('copy')) this.props.acceptBlock();
  };

  toggleOpen = () => {
    if (!this.closable) return;

    if (this.state.open) {
      localStorage.setItem('currentClosed',
        `${localStorage.getItem('currentClosed') || ''}|${this.props.campaignId}`);
      this.setState({contentOpen: false});
      setTimeout(() => this.setState({open: false}), 200);
      return;
    }

    localStorage.setItem('currentClosed',
      localStorage.getItem('currentClosed').replace(`|${this.props.campaignId}`, ''));
    this.setState({open: true});
    setTimeout(() => this.setState({contentOpen: true}), 500);
  }

  render() {
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';

    return (
      <div>
        <div
          id="wio_notifv2"
          style={this.getStyle()}
          className={`WioFloat WioBanner ${banClass}`}
        >
          <div
            id="wioIconBlock"
            style={this.getIconStyle()}
            onClick={this.toggleOpen}
          >
            <img
              alt="icon"
              src={`${this.AssetsPath}${Utils.getCampaignData(this.props.iconUrl)}`}
              style={{ width: '100%' }}
            />
          </div>
          <div
            id="wioContentBlock"
            style={{
              transition: 'opacity 500ms linear',
              width: '80%',
              display: this.state.open ? 'flex' : 'none',
              flexDirection: 'row',
              opacity: this.state.contentOpen ? 1 : 0,
            }}
          >
            <div
              id="wioContent"
              style={{ width: '70%', padding: '5px 5px 5px 0', textAlign: 'initial' }}
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            />
            <div style={this.getButtonsStyle()}
            >
              <button
                style={this.getAcceptButtonStyle()}
                onClick={this.handleAcceptClick}
              >
                {this.state.showGift
                  ? Utils.getCampaignData(this.props.useText, 'Utiliser')
                  : Utils.getCampaignData(this.props.acceptText, 'Voir')}
              </button>
              <button
                id="wioBlockExit"
                style={this.getExitButtonStyle()}
                onClick={this.closable ? this.toggleOpen : this.props.refuseBlock}
              >
                {this.state.showGift
                  ? Utils.getCampaignData(this.props.closeText, 'Fermer')
                  : Utils.getCampaignData(this.props.refuseText, 'Fermer')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
